<template>
<div class="container wc-container wc-container-720">
<Row :gutter="16">
  <Col span="24">
  <div class="page-settings">
    <div class="settings-item" style="margin-bottom:30px">
      <h4 class="settings-item--label">Enable P2P</h4>
      <p style="width:100%">This technology allows off-loading origin server or delivery network by exchanging media data between viewers. Internet Explorer doesn't works with this solution</p>
      <i-switch v-model="enableP2P" @on-change="onEnableP2PChange" style="position:absolute; right:0;" />
    </div>
  </div>
  <div class="page-settings">
    <div class="settings-item" style="margin-bottom:30px">
      <h4 class="settings-item--label">Enable VOD</h4>
      <p style="width:100%">Put recording of the webcast on the page</p>
      <i-switch v-model="enableVOD" @on-change="onEnableVODChange" style="position:absolute; right:0;" />
    </div>
  </div>
  <Card style="margin-bottom:30px;">
    <h3>Add new stream</h3>
    <Form ref="formInline" :model="streamForm" inline>
      <FormItem style="width:100%;">
        <Input v-model="streamForm.name" placeholder="Stream Name">
        <Button type="primary" slot="append" @click="addStream(streamForm)">Add</Button>
        </Input>
      </FormItem>
    </Form>
  </Card>

  <Card v-for="(stream, index) in streams" :key="stream._id" style="margin-bottom:32px;">
    <p slot="title">Stream #{{index}}</p>
    <Form>
      <FormItem label="Stream Name">
        <Input v-model="stream.name"></Input>
      </FormItem>
      <FormItem>
        <p style="display:block;"><b>Server URL:</b> {{appSettings.originServerUrl}}</p>
        <p style="display:block;"><b>Stream ID:</b> {{stream.streamId}}</p>
      </FormItem>
      <FormItem label="Player Url">
        <Input v-model="stream.playerUrl"></Input>
      </FormItem>
      <FormItem label="VOD Url" v-if="enableVOD">
        <Input v-model="stream.vodUrl"></Input>
      </FormItem>
      <FormItem>
        <Button type="default" style="float:right;" @click="deleteStream(stream._id)">Delete</Button>
        <Button type="primary" style="float:right; margin-right:16px;" @click="updateStream(stream._id, stream)">Save</Button>
      </FormItem>
    </Form>
  </Card>


  </Col>
</Row>
</div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'
import HashID from '@/helpers/hashid'

export default {
  data() {
    return {
      streamList: {},
      streamForm: {},
      isSaving: false,
      enableP2P: false,
      enableVOD: false
    }
  },
  computed:{
    ...mapGetters('webcast', {
      webcast: 'getCopy'
    }),
    ...mapGetters('stream', {findStreamsInStore: 'find'} ),
    ...mapGetters('appsettings', {appSettings: 'getCopy'} ),
    streams () {
      this.$data.streamList = _.toPlainObject(this.findStreamsInStore().data)
      return this.$data.streamList
    }
  },
  methods: {
    ...mapActions('stream', {
      findStreams: 'find',
      createStreamAction: 'create',
      updateStreamAction: 'update',
      deleteStreamAction: 'remove'
    }),
    ...mapActions('webcast', {
      createWebcastAction: 'create',
      updateWebcastAction: 'patch'
    }),
    addStream(data){
      const streamData = {
        webcastId: this.$store.state.webcast.copy._id,
        name: data.name,
        streamId: HashID.generate()
      }
      console.log(streamData);
      this.createStreamAction(streamData).then((resp)=>{
        this.$Message.success('Stream  <b>'+resp.name+'</b> has been created');
      })
    },
    updateStream(streamId, data){
      this.updateStreamAction([streamId, data]).then((resp)=>{
        this.$Message.success('Stream <b>'+resp.name+'</b> has been updated');
      });
    },
    deleteStream(streamId){
      this.deleteStreamAction(streamId).then((resp)=>{
        this.$Message.success('Stream <b>'+resp.name+'</b> has been removed');
      })
    },
    onEnableP2PChange(value){
      this.updateWebcastAction([this.webcast._id, {enableP2P: value}, {}]).then((response) => {
        this.$Message.success('Webcast has been updated');
      })
    },
    onEnableVODChange(value){
      this.updateWebcastAction([this.webcast._id, {enableVOD: value}, {}]).then((response) => {
        this.$Message.success('Webcast has been updated');
      })
    }
  },
  created() {
    this.findStreams({
      query:{
        webcastId: this.$store.state.webcast.copy._id
      }
    });

    this.enableP2P = this.webcast.enableP2P;
    this.enableVOD = this.webcast.enableVOD;
  }
}
</script>

<style lang="scss" scoped>
  .settings {
		&-item {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
			padding: 30px 0;
      border-bottom: 0.5px solid #e9eaec;
			&:not(:last-of-type) {
				border-bottom: 0.5px solid #e9eaec;
			}
		}

		&-text {
			width: 100%;
			color: #abacaf;
		}
	}
</style>
